<template>
    <v-dialog v-model="dialog" width="700" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #121212 !important; display: flex; justify-content: space-between; align-items: center; color: white;">
                <div>
                    <span class="font-weight-bold text-h6" style="font-family: Saira Condensed, sans-serif;">{{ main_title }}</span>
                    <div class="text-caption" style="font-family: Saira Condensed, sans-serif;">{{ sub_title }}</div>
                </div>
                <v-btn :disabled="loading" flat icon color="primary" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 200px);">
                <v-form ref="form" class="mt-4">
                    <v-row dense>
                        <v-col cols="12">
                            <v-switch
                                v-model="status"
                                :label="$t('Fields_Label.Products.Status')"
                                color="green"
                                false-value="inactive"
                                true-value="active"
                                inset
                                style="font-family: Saira Condensed, sans-serif;"
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="title"
                                :rules="[formRules.required]"
                                :label="$t('Fields_Label.Products.Title')"
                                type="text"
                                variant="outlined"
                                density="comfortable"
                                color="primary"
                                style="font-family: Saira Condensed, sans-serif;"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select
                                v-model="category"
                                :rules="[formRules.required]"
                                :label="$t('Fields_Label.Products.Product_Category')"
                                variant="outlined"
                                density="comfortable"
                                color="primary"
                                style="font-family: Saira Condensed, sans-serif;"
                                :items="categoryData"
                                item-title="title"
                                item-value="value"
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="description"
                                :rules="[formRules.required, formRules.noSpacesOnly]"
                                :label="$t('Fields_Label.Products.Description')"
                                type="text"
                                variant="outlined"
                                density="comfortable"
                                color="primary"
                                style="font-family: Saira Condensed, sans-serif;"
                            ></v-textarea>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="requiredPoints"
                                :rules="[formRules.required, formRules.maxLength, formRules.minValue]"
                                :label="$t('Fields_Label.Products.Required_Points')"
                                type="number"
                                variant="outlined"
                                density="comfortable"
                                color="primary"
                                style="font-family: Saira Condensed, sans-serif;"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="quantity"
                                :rules="[formRules.required, formRules.minValue]"
                                :label="$t('Fields_Label.Products.Quantity')"
                                type="number"
                                variant="outlined"
                                density="comfortable"
                                color="primary"
                                style="font-family: Saira Condensed, sans-serif;"
                            ></v-text-field>
                        </v-col>
                        <v-col v-if="imgChange == true" cols="12">
                            <v-file-input
                                v-model="file"
                                :rules="[formRules.required, formRules.fileSize]"
                                accept="image/*"
                                :label="$t('Fields_Label.Products.Image_File')"
                                variant="outlined"
                                density="comfortable"
                                color="primary"
                                show-size
                                style="font-family: Saira Condensed, sans-serif;"
                            ></v-file-input>
                        </v-col>
                        <v-col v-show="imgChange == false" cols="12" md="6">
                            <v-img
                            class="mx-auto"
                            rounded="lg"
                            :src="imageUrl"
                            lazy-src="https://picsum.photos/id/11/100/60"
                            loading>
                            <template v-slot:placeholder>
                                <div class="d-flex align-center justify-center fill-height">
                                    <v-progress-circular
                                    color="grey-lighten-4"
                                    indeterminate
                                    ></v-progress-circular>
                                </div>
                            </template>
                            </v-img>
                        </v-col>
                        <v-col v-if="imgChange == false" cols="12" md="6">
                            <v-btn @click="imgChange = true" class="mr-1 text-subtitle-1" text="Change Image" variant="elevated" elevation="1" color="primary" style="font-family: Saira Condensed, sans-serif;">
                            </v-btn>
                        </v-col>
                        <!-- <v-col cols="12">
                            <v-text-field
                                v-model="rewardsCondition"
                                :rules="[formRules.required, formRules.noSpacesOnly]"
                                label="Reward Condition"
                                type="text"
                                variant="outlined"
                                density="comfortable"
                                color="primary"
                                style="font-family: Saira Condensed, sans-serif;"
                            ></v-text-field>
                        </v-col> -->
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1 text-subtitle-1" :disabled="loading" :text="$t('Buttons.Cancel')" variant="outlined" elevation="1" @click="closeDialog()" style="font-family: Saira Condensed, sans-serif;"></v-btn>
                <v-btn class="mr-1 text-subtitle-1" :loading="loading" :text="$t('Buttons.Save')" variant="elevated" elevation="1" color="primary" @click="validateForm()" style="font-family: Saira Condensed, sans-serif;"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-snackbar
        v-model="snackbar"
        :timeout="2500"
        color="secondary"
        location="top">
        <v-icon>mdi-alert-circle</v-icon>
        <span class="ml-2" style="font-family: Saira Condensed, sans-serif;">{{ snackText }}</span>
    </v-snackbar>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'

export default defineComponent({
    emits: ["refresh"],
    data(){
        return {
            dialog: false,
            main_title: null,
            sub_title: null,
            action: null,
            loading: false,
            
            snackbar: false,
            snackText: null,

            id: null,
            title: null,
            description: null,
            quantity: null,
            requiredPoints: null,
            category: null,
            rewardsCondition: null,
            file: null,
            status: 'active',

            imgChange: false,
            imageUrl: null,

            formRules: {
                required: value => !!value || 'Required',
                minValue: value => (value && value != 0) || 'Must be greater than 0',
                maxLength: value => (value && value.toString().length <= 10) || 'Must be less than or equal to 10 characters',
                noSpacesOnly: value => (value && value.trim().length > 0) || 'This cannot be just spaces',
                fileSize: value => {
                    if (value[0]){
                        return value[0].size <= 2 * 1024 * 1024 || 'File size must be less than 2MB';
                    }
                }
            },

            categoryData: [
                { title: 'Kick', value: 'kick'},
                { title: 'Stake', value: 'stake'}
            ],
        }
    },
    methods: {
        initAdd(){
            this.dialog = true
            this.main_title = this.$t('DialogTitle.Add_Product.Header')
            this.sub_title = this.$t('DialogTitle.Add_Product.Sub_Title')
            this.action = 'add'

            this.status = 'active'
            this.imgChange = true
        },
        initUpdate(data){
            this.dialog = true
            this.main_title = this.$t('DialogTitle.Edit_Product.Header')
            this.sub_title = this.$t('DialogTitle.Edit_Product.Sub_Title')
            this.action = 'edit'

            this.id = data._id
            this.title = data.title
            this.description = data.description
            this.status = data.status
            this.requiredPoints = data.requiredPoints
            this.category = data.category
            this.rewardsCondition = data.rewardsCondition
            this.imageUrl = data.imageUrl

            if(this.imageUrl){
                this.imgChange = false
            }
            else{
                this.imgChange = true
            }
        },
        async validateForm(){
            const { valid } = await this.$refs.form.validate()

            if(valid){
                const token = localStorage.getItem('maherco-admin-accesstoken')
                
                let formData = {
                    id: this.id,
                    title: this.title,
                    description: this.description,
                    category: this.category,
                    requiredPoints: this.requiredPoints,
                    status: this.status,
                    quantity: this.quantity,
                    file: this.file ?? null,
                }

                this.loading = true
                if(this.action == 'add'){
                    axios.post(process.env.VUE_APP_SERVER_URL + '/api/admin/store/products', formData, { 
                        headers: { 
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data',
                            'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                        }
                    }).then((res)=>{
                        if(res.data.status == 200){
                            this.$emit('refresh')
                            this.loading = false
                            this.snackText = res.data.message
                            this.snackbar = true
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error) => {
                        if (error.response) {
                            if (error.response.status === 401) {
                                    localStorage.removeItem("vuex");
                                    localStorage.removeItem("maherco-admin-accesstoken");
                                    window.location.reload();
                            } else {
                                console.log(`Error: ${error.response.status}`);
                            }
                        } 
                        else if (error.request) {
                            console.log('No response received', error.request);
                        } else {
                            console.log('Error', error.message);
                        }
                    });
                }
                else if(this.action == 'edit'){
                    axios.put(process.env.VUE_APP_SERVER_URL + `/api/admin/store/products/${this.id}`, formData, { 
                        headers: { 
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data',
                            'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                        }
                    }).then((res)=>{
                        if(res.data){
                            this.$emit('refresh')
                            this.loading = false
                            this.snackText = res.data.message
                            this.snackbar = true
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error) => {
                        if (error.response) {
                            if (error.response.status === 401) {
                                    localStorage.removeItem("vuex");
                                    localStorage.removeItem("maherco-admin-accesstoken");
                                    window.location.reload();
                            } else {
                                console.log(`Error: ${error.response.status}`);
                            }
                        } 
                        else if (error.request) {
                            console.log('No response received', error.request);
                        } else {
                            console.log('Error', error.message);
                        }
                    });
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
    }
})
</script>

<style scoped>

</style>